import React from 'react'
import "./semiCircleCard.scss"
import '../../../styles/fontSizes.scss'
import Text from '../../atoms/text/text';
import ArrowButton from 'componets/atoms/arrowButton/arrowButton'; 
import palette from "styles/palette.scss"
const SemiCircleCard = ({className, data, textSize, type, isSecretary, optionalHandle}) =>{
    return(
        <>
        { (type && type === "oval")?
            <div className = {`${className} semi-circle-c___container--oval font-size--${textSize}`}>
                <div className = {"semi-circle-c___research"}>
                    {data.title && <Text color = {palette.darkBrown} type = "h" textSize={textSize+1}>{data.title}</Text>}
                    <br/>
                    {data.description && <Text color = {"black"} type = "p" textSize={textSize}>{data.description}</Text>}
                </div>
                <ArrowButton color ={palette.darkBrown} type={"right--2"} textSize = {2} handleClick = {isSecretary?optionalHandle:() => window.open(data.link)}/>
            </div>
        :
            <div className = {`${className} semi-circle-c___container font-size--${textSize}`}>
                
                {data.titulo && <Text color = {"black"} type = "h" textSize={textSize+1}>{data.titulo}</Text>}
                {data.descripcionCorta && <Text color = {"black"} type = "p" textSize={textSize}>{data.descripcionCorta}</Text>}
                {data.vinculo && <ArrowButton type={"right--2"} textSize = {2} handleClick = {() => window.open(data.vinculo)}/>}
            </div>
        }
        </>
    )
}

export default SemiCircleCard;